<template>
  <div class="flex items-center gap-1.25rem">
    <div class="w-.3125rem h-1.5rem bg-#ff6600cc rounded-md"></div>
    <div class="text-1.25em text-[rgba(0,0,0,0.851)]">
      <slot></slot>
    </div>
  </div>
</template>